import styled from "styled-components";

import type { Content } from "api/services/content/schemas/lessons";
import { BodyLong, H3, Title } from "shared/atoms/PatientApp";
import { parseHTML } from "utils/parseHTML";

import type { TranslationSubset } from "./LessonPreviewMobile";

interface Props {
  translation: TranslationSubset;
}

export const LessonScreen: React.FC<Props> = ({ translation }) => {
  const { content, image_url, title } = translation;

  const lessonContent = typeof content === "string" ? (JSON.parse(content) as Content[]) : (content as Content[]);

  return (
    <>
      <Title>{title}</Title>
      <ActivityTopBackground>{image_url && <img alt={title} src={image_url} />}</ActivityTopBackground>
      <LessonContent>
        {lessonContent &&
          lessonContent.map(({ type, content: c }, index: number) => {
            if (!c) {
              return null;
            }

            const key = `content-${index}`;
            switch (type) {
              case "heading":
                return <StyledH3 key={key}>{c}</StyledH3>;
              case "paragraph":
                return <BodyLong key={key} dangerouslySetInnerHTML={{ __html: parseHTML(c) }} />;
              case "image":
                return (
                  <ImageContainer key={key}>
                    <img alt={title} src={c} />
                  </ImageContainer>
                );
              default:
                return null;
            }
          })}
      </LessonContent>
    </>
  );
};

const ActivityTopBackground = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px;

  & > img {
    height: 145px;
    width: 145px;
  }
`;

const LessonContent = styled.div`
  padding: 32px 16px 24px;
  background: ${({ theme }) => theme.colors.white};
`;

const StyledH3 = styled(H3)`
  margin-bottom: 16px;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 8px 0;

  & > img {
    max-width: 100%;
  }
`;
